export enum MfaMode {
  NORMAL = 'NORMAL',
  TOKEN = 'TOKEN',
  MAIL = 'MAIL',
}
